import { useToasts } from '../lib/toast'

export default function Toaster() {
  const items = useToasts()
  if (items.length === 0) return null
  return (
    <div className="fixed bottom-20 right-4 z-50 flex w-72 flex-col gap-2 md:bottom-4">
      {items.map((t) => (
        <div
          key={t.id}
          className={`rounded-xl px-4 py-3 text-sm font-medium text-white shadow-lg ${
            t.type === 'error'
              ? 'bg-rose-600'
              : t.type === 'success'
                ? 'bg-emerald-600'
                : 'bg-slate-800'
          }`}
        >
          {t.message}
        </div>
      ))}
    </div>
  )
}
